export class DemonstrativoResultado {
    public Id: number;
    public Codigo: number;
    public Descricao: string;
    public GrupoId: string;
    public ReceitaDespesa: string;
    public Formula: string;
    public DR: DemonstrativoResultado[];
    public Valor: number;
    public PorcentagemGrupo: number;
    public CodigoCompleto: string;
    public Exibir: boolean;
    public PossuiFilhos: boolean;
    public MostrarFilhos: boolean;
    /** 'R' | 'D' | null — resolvido no front, ver RelatorioDRComponent.resolverTipos() */
    public Tipo: string;
}